import { HttpMethods, sendRequest } from "../util/ApiHelper";

const CONTROLLER_NAME = "MobileApproval";

export interface ProcessWorkOrderActionListData {
  RequestObject: {
    WorkOrderActionListData: {
      WoBase?: string;
      Status?: string | null;
      Comments?: string;
      Action?: string;
      NextReviewer?: string | null;
      AssignedTo?: string | null;
    }[];
  };
  Confirmation: any;
}

export interface GetReviewerData {
  plant: string;
  user: string | null;
  type: number;
}

export interface ProcessPurchaseOrderData {
  Action: string;
  Comments?: string;
  NextReviewer: string;
  PurchaseOrder: string;
}

export const changeStatus = async (data: ProcessWorkOrderActionListData) => {
  return await sendRequest(
    HttpMethods.POST,
    `${CONTROLLER_NAME}/ProcessWorkOrderActionList`,
    data
  );
};

export const getRequisitionLines = async (reqNum: string) => {
  return await sendRequest(
    HttpMethods.GET,
    `${CONTROLLER_NAME}/GetRequisitionLines`,
    undefined,
    {
      reqNum: reqNum,
    }
  );
};

export const getReviewers = async (data: GetReviewerData) => {
  return await sendRequest(
    HttpMethods.GET,
    `${CONTROLLER_NAME}/GetReviewers`,
    undefined,
    {
      ...data,
      type: String(data.type),
    }
  );
};

// --- Purchase Order approvals (US 806719) ---
// GetPurchaseOrderLines/GetPurchaseOrderActivityLog/ProcessPurchaseOrders are all
// mobile-specific endpoints on MobileApprovalController (thin wrappers over the shared
// PO approval business logic). ProcessPurchaseOrders resolves the full PO key from the
// combined display PO number that the mobile queue card carries.

export const getPurchaseOrderLines = async (poNumber: string) => {
  return await sendRequest(
    HttpMethods.GET,
    `${CONTROLLER_NAME}/GetPurchaseOrderLines`,
    undefined,
    {
      poNumber: poNumber,
    }
  );
};

export const getPurchaseOrderActivityLog = async (poNumber: string) => {
  return await sendRequest(
    HttpMethods.GET,
    `${CONTROLLER_NAME}/GetPurchaseOrderActivityLog`,
    undefined,
    {
      poNumber: poNumber,
    }
  );
};

export const processPurchaseOrders = async (
  data: ProcessPurchaseOrderData[]
) => {
  let params = data.map((item) => {
    return {
      RequestObject: item,
      Confirmation: {},
    };
  });
  // Mobile-specific endpoint: resolves the full PO key from the combined display
  // PO number, then runs the shared PO approve/review/reject business logic.
  // Returns POMassUpdateActionResult with PoInfoResult[].MessageList[].Text.
  return await sendRequest(
    HttpMethods.POST,
    `${CONTROLLER_NAME}/ProcessPurchaseOrders`,
    params
  );
};
